// src/App.tsx
import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import AdminLayout from "./layouts/AdminHeaderLayout";
// Admin pages
import Dashboard from "./pages/Dashboard";
import Orders from "./pages/Orders";
import Products from "./pages/Products";
import Categories from "./pages/Categories";
import Reviews from "./pages/Reviews";
import Login from "./pages/Login";
import CategoryForm from "./pages/CategoryForm";
import ProductTypes from "./pages/ProductTypes";

// Forms
import ProductForm from "./pages/ProductForm";
import UploadProductImages from "./pages/ProductImages";
import ProductTypeForm from "./pages/ProductTypeForm";

const App: React.FC = () => {
  return (
    <Router>
      <Routes>
        {/* Admin login (no layout) */}
        <Route path="/login" element={<Login />} />

        {/* Admin pages with layout */}
        <Route path="/" element={<AdminLayout />}>
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="orders" element={<Orders />} />
          <Route path="products" element={<Products />} />
          <Route path="products/new" element={<ProductForm />} />
          <Route path="categories" element={<Categories />} />
          <Route path="reviews" element={<Reviews />} />
          <Route path="products/edit/:id" element={<ProductForm />} />
          <Route path="categories/edit/:id" element={<CategoryForm />} />
          <Route path="uploadimages" element={<UploadProductImages />} />
          <Route path="categories/new" element={<CategoryForm />} />
          <Route path="product-types" element={<ProductTypes />} />
          <Route path="product-types/new" element={<ProductTypeForm />} />
          <Route path="product-types/edit/:id" element={<ProductTypeForm />} />
        </Route>

        {/* Default redirect */}
        <Route path="*" element={<Navigate to="/dashboard" replace />} />
      </Routes>
    </Router>
  );
};

export default App;
